export const GET_SERVICE_PROVIDER_CUSTOMERS_LIST = null;
export const GET_SERVICE_PROVIDER_CUSTOMERS_SELECT_LIST = null;
export const SELECTED_SERVICE_PROVIDER_CUSTOMER_ID = null;
export const GET_SERVICE_PROVIDER_CUSTOMER_DETAILS = null;
export const SELECTED_SERVICE_PROVIDER_CUSTOMER_ID_FOR_APPOINTMENT_VIEW_DETAILS = null;